// AS REGRAS DA TELA DO AVISO AO CLIENTE (18/10/2026).
//
// O aviso de movimentação morava nas trilhas do Follow-up; mudou para o agente do cliente no
// Lumos (configurar) e para o Jurídico (aprovar). Aqui fica o que as três telas — a aba do
// agente, o painel do Jurídico e a ficha do processo — leem do mesmo jeito.

// As variáveis do texto padrão (Legal::ConfiguracaoDoAviso::VARIAVEIS).
export const CAMPO_DO_TEXTO = {
  aceitas: ['primeiro_nome', 'processo', 'data'],
  obrigatorias: [],
};

const HORA = 3600000;

export const horasDesde = (iso, agora = Date.now()) =>
  Math.max(0, Math.floor((agora - new Date(iso).getTime()) / HORA));

export const horasAte = (iso, agora = Date.now()) =>
  Math.max(0, Math.ceil((new Date(iso).getTime() - agora) / HORA));

// Quando o aviso foi proposto e quando vence, como CÓDIGO + número (a tela traduz):
// "agora há pouco", "há 5 h", "há 2 dias" · "vence em 3 dias", "vence em 4 h".
export const tempoDoAviso = (propostoEm, venceEm, agora = Date.now()) => {
  const ha = horasDesde(propostoEm, agora);
  const falta = horasAte(venceEm, agora);
  let desde = { codigo: 'HA_DIAS', n: Math.floor(ha / 24) };
  if (ha < 1) desde = { codigo: 'AGORA', n: 0 };
  else if (ha < 24) desde = { codigo: 'HA_HORAS', n: ha };
  const vence =
    falta < 24
      ? { codigo: 'VENCE_HORAS', n: Math.max(falta, 1) }
      : { codigo: 'VENCE_DIAS', n: Math.round(falta / 24) };
  return { desde, vence };
};

const SAIU = ['reservado', 'solicitado', 'aceito', 'entregue', 'lido'];

// O que aconteceu com o aviso de um andamento, como CÓDIGO + tom (a tela traduz). Só a
// exceção ganha cor: esperando é âmbar, avisado é teal, o resto é neutro.
export const estadoDoAviso = toque => {
  const motivo = String(toque?.motivo || '');
  if (toque?.estado === 'proposto')
    return { codigo: 'ESPERANDO', tom: 'ambar' };
  if (SAIU.includes(toque?.estado)) return { codigo: 'AVISADO', tom: 'ok' };
  if (toque?.estado === 'desconhecido')
    return { codigo: 'SEM_CONFIRMACAO', tom: 'neutro' };
  if (toque?.estado === 'barrado') return { codigo: 'SEGURADO', tom: 'neutro' };
  if (toque?.estado === 'cancelado') {
    if (motivo.startsWith('sem aviso'))
      return { codigo: 'ROTINA', tom: 'neutro' };
    if (motivo.startsWith('descartado'))
      return { codigo: 'DESCARTADO', tom: 'neutro' };
    if (motivo.startsWith('venceu')) return { codigo: 'VENCEU', tom: 'neutro' };
    // Substituído por um mais novo: o cliente recebe um aviso só, que o andamento novo mostra.
    if (motivo.startsWith('substituído')) return null;
    return { codigo: 'NAO_SAIU', tom: 'neutro' };
  }
  return null;
};

// Andamento → estado do aviso dele. Um aviso cobre vários andamentos; o mais novo vale.
export const avisosPorAndamento = toques => {
  const mapa = {};
  [...(toques || [])]
    .sort((a, b) => String(a.proposto_em).localeCompare(String(b.proposto_em)))
    .forEach(toque => {
      const estado = estadoDoAviso(toque);
      if (!estado) return;
      (toque.andamento_ids || []).forEach(id => {
        mapa[id] = { ...estado, quando: toque.quando };
      });
    });
  return mapa;
};

// O modelo da Meta sugerido para o escritório submeter (spec F4 §10.6).
export const MODELO_SUGERIDO = {
  nome: 'aviso_andamento_processo',
  corpo:
    'Olá, {{1}}! O seu processo {{2}} teve um novo andamento em {{3}}. Se quiser, responda esta mensagem que a equipe do escritório explica o que mudou.',
  botao: 'Quero entender',
};
